// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-proffesional-specialty-panel__container__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: calc( var( --space-x3 ) - var( --space-quarter ));
}

.signup-proffesional-specialty-panel__container__title span {
    font-size: calc( var( --space-and-half ) + 1px );
}

.signup-proffesional-specialty-panel__subtitle {
    /* TODO New_Subtitle 2 */
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    display: flex;
    align-items: center;
    letter-spacing: 0.0015em;
    /* gray-base */
    color: #4D5451;
    justify-content: center;
}

.proffesional-specialties-form__form .proffesional-specialties-form__form__input {
  margin: var( --space-half ) 0 0 0;   
  background: #ECECEC; /* TODO change to var*/
  border-radius: calc( var( --space-half ) + 1px );
}

.signup-proffesional-specialty-panel__label {
    margin-top: calc( var( --space-x3 ) + 2px); 
    font-family: Roboto; /* TODO change to var*/
    font-style: normal;
    font-weight: 500; /* TODO change to var*/
    font-size: calc( var( --space ) + 3px);
    line-height: calc( var( --space-and-half ) - 2px);
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var( --primary-dark-color );
}

.proffesional-specialties-form__form__actions {
    display: flex;
    justify-content: center;
    margin-top: calc( var( --space-x3 ) + var( --space-half ) );
}

.proffesional-specialties-form__form__actions .button{
    background: #30B36B; /* TODO change to var*/
    border-radius: calc( var( --space-quarter ) + 2px );
}

.proffesional-specialties-form__form__actions .button span{
    font-family: Roboto; /* TODO change to var*/
    font-style: normal;
    font-weight: 500; /* TODO change to var*/
    font-size: calc( var( --space ) + 3px);
    line-height: calc( var( --space-and-half ) - 2px);
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;    
    color: var( --white-color );
    text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/signup-proffesional-specialty-panel/SignUpProffesionalSpecialtyPanelComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gEAAgE;AACpE;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,cAAc;IACd,cAAc;IACd,uBAAuB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB,EAAE,sBAAsB;EAC3C,gDAAgD;AAClD;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB,EAAE,sBAAsB;IAC3C,kBAAkB;IAClB,gBAAgB,EAAE,sBAAsB;IACxC,sCAAsC;IACtC,iDAAiD;IACjD,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,2DAA2D;AAC/D;;AAEA;IACI,mBAAmB,EAAE,sBAAsB;IAC3C,mDAAmD;AACvD;;AAEA;IACI,mBAAmB,EAAE,sBAAsB;IAC3C,kBAAkB;IAClB,gBAAgB,EAAE,sBAAsB;IACxC,sCAAsC;IACtC,iDAAiD;IACjD,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,2BAA2B;IAC3B,0BAA0B;AAC9B","sourcesContent":[".signup-proffesional-specialty-panel__container__title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: calc( var( --space-x3 ) - var( --space-quarter ));\n}\n\n.signup-proffesional-specialty-panel__container__title span {\n    font-size: calc( var( --space-and-half ) + 1px );\n}\n\n.signup-proffesional-specialty-panel__subtitle {\n    /* TODO New_Subtitle 2 */\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 23px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0015em;\n    /* gray-base */\n    color: #4D5451;\n    justify-content: center;\n}\n\n.proffesional-specialties-form__form .proffesional-specialties-form__form__input {\n  margin: var( --space-half ) 0 0 0;   \n  background: #ECECEC; /* TODO change to var*/\n  border-radius: calc( var( --space-half ) + 1px );\n}\n\n.signup-proffesional-specialty-panel__label {\n    margin-top: calc( var( --space-x3 ) + 2px); \n    font-family: Roboto; /* TODO change to var*/\n    font-style: normal;\n    font-weight: 500; /* TODO change to var*/\n    font-size: calc( var( --space ) + 3px);\n    line-height: calc( var( --space-and-half ) - 2px);\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var( --primary-dark-color );\n}\n\n.proffesional-specialties-form__form__actions {\n    display: flex;\n    justify-content: center;\n    margin-top: calc( var( --space-x3 ) + var( --space-half ) );\n}\n\n.proffesional-specialties-form__form__actions .button{\n    background: #30B36B; /* TODO change to var*/\n    border-radius: calc( var( --space-quarter ) + 2px );\n}\n\n.proffesional-specialties-form__form__actions .button span{\n    font-family: Roboto; /* TODO change to var*/\n    font-style: normal;\n    font-weight: 500; /* TODO change to var*/\n    font-size: calc( var( --space ) + 3px);\n    line-height: calc( var( --space-and-half ) - 2px);\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;    \n    color: var( --white-color );\n    text-transform: capitalize;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
